export const MONETARY_PREFIX = '$';

const maskValue = (value: string | number) => {
  return `$${value
    .toString()
    .replace(/\D/g, '')
    .split('')
    .reverse()
    .map((digit, index) => (index !== 0 && index % 3 === 0 ? `${digit},` : digit))
    .reverse()
    .join('')}`;
};

export const removeCurrencySign = (value: string | number) => {
  return value.toString().replace('$', '');
};

export const removeNonDigits = (value: any) => {
  return value?.toString().replace(/\D/g, '').toString();
};

export const removeSpaces = (value: string) => {
  return value.replace(/\s+/g, '');
};

export const maskMonetaryValue = (value: string | number | undefined | null) => {
  if (value === 0) {
    return maskValue(value);
  }

  if (!value || !Number(removeNonDigits(value))) {
    return '';
  }

  if (value.toString().includes('.')) {
    const split = value.toString().split('.');

    const formatted = maskValue(split[0]);

    return `${formatted}.${split[1]}`;
  }

  return maskValue(value);
};

export const maskMonetaryValueAllowZero = (value: string | number | null) => {
  if (!value || !removeCurrencySign(value)) {
    return '';
  }

  const digitsOnly = Number(removeNonDigits(value));

  if (digitsOnly === 0) {
    return '$0';
  }

  return maskValue(digitsOnly);
};

export const getErrorMessageForRequiredFields = (requiredField: string) => `${requiredField} is required`;

export const getLastSymbols = (value: string | null, amountOfSymbols: number) => {
  if (!value) {
    return;
  }

  return value.toString().slice(value.length - amountOfSymbols, value.length);
};

export const maskSSN = (number: string, isMaskDisabled: boolean = false) => {
  const SSN = number?.replace(/\D/g, '').match(/(\d{0,3})(\d{0,2})(\d{0,4})/) || '';

  if (isMaskDisabled) {
    return SSN[0];
  }

  return !SSN[2] ? SSN[1] : `${SSN[1]}-${SSN[2]}${SSN[3] ? `-${SSN[3]}` : ''}`;
};

export const ChangeFirstLetterToUppercase = (label?: string) => {
  return label
    ?.split(' ')
    .map((e) => e[0].toUpperCase() + e.substr(1))
    .join(' ');
};

export const removeQuestionMark = (value?: string | null) => {
  return value ? value.replace('?', '') : '';
};

export const convertStringToBoolean = (string: string) => {
  return !!string && string.toLowerCase() === 'true';
};

export const getStreetAddress = (streetNumber: string, streetName: string) => {
  const formattedStreetNumber = streetNumber ? `${streetNumber} ` : '';
  const formattedStreetName = streetName ? `${streetName}` : '';

  return `${formattedStreetNumber}${formattedStreetName}`;
};

export const getStreetNumberFromStreetAddress = (streetAddress: string) => {
  const splittedString = streetAddress ? streetAddress.split(' ') : [];
  const streetNumber = Number(splittedString[0]);

  return streetNumber ? streetNumber.toString() : '';
};

export const getStreetNameFromStreetAddress = (streetAddress: string) => {
  const streetNumber = getStreetNumberFromStreetAddress(streetAddress);

  if (streetNumber) {
    return streetAddress.replace(`${streetNumber} `, '');
  }

  return streetAddress;
};
